module.exports = __webpack_public_path__ + "static/media/two-person-black.d7400021.svg";